// extracted by mini-css-extract-plugin
export default {"Trip":"Trip_Trip__lAXcK","TripInput":"Trip_TripInput__+AYCO"};